@if (isLoading) {
  <div class="xi-loader-container__center configuration-details__loader">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}

<ng-container *transloco="let t; read: 'configurations.details'">
  <div class="configuration-details__wrapper">
    @if (configuration) {
      <a [routerLink]="[configurationsRoute]" class="configuration-details__back">
        <xi-icon icon="arrow_left" color="CX"></xi-icon
        ><span class="configuration-details__back-text">{{ t('back-to-configurations') }}</span>
      </a>
      <div class="configuration-details__title-wrapper">
        <h1 class="configuration-details__name">
          {{ configuration.name }}
        </h1>
        @if (!configuration.removed) {
          <div>
            <span>
              <xi-icon-button
                color="CX"
                icon="settings"
                buttonSize="large"
                (onClick)="onOpenConfigurationOptions()"
                [tooltip]="{ text: t('settings'), direction: 9 }"
              >
              </xi-icon-button>
            </span>
            <span [matMenuTriggerFor]="configurationMenuTrigger">
              <xi-icon-button color="CX" icon="kabob" buttonSize="large"> </xi-icon-button>
            </span>
            <mat-menu #configurationMenuTrigger class="menu-with-xi-icons">
              <div
                [matTooltip]="isReadOnly ? t('cannot-test-readonly') : undefined"
                matTooltipPosition="left"
              >
                <button mat-menu-item [disabled]="isReadOnly" (click)="onTestConfiguration()">
                  {{ t('test') }}
                </button>
              </div>
              <button mat-menu-item disabled>{{ t('download') }}</button>
              <div
                [matTooltip]="downloadConfigurationTooltip(configuration)"
                matTooltipPosition="left"
              >
                <button
                  mat-menu-item
                  [disabled]="!canDownloadConfiguration(configuration)"
                  (click)="onDownloadConfiguration(configuration)"
                  class="configuration-details__download-button"
                >
                  {{ t('configuration') }}
                </button>
              </div>
              <div [matTooltip]="downloadTaxonomyTooltip(configuration)" matTooltipPosition="left">
                <button
                  mat-menu-item
                  [disabled]="!canDownloadTaxonomy(configuration)"
                  (click)="onDownloadTaxonomy($event, configuration)"
                  class="configuration-details__download-button"
                >
                  {{ t('taxonomy') }}
                </button>
              </div>
              @if (!isReadOnly) {
                <div
                  [matTooltip]="cloneConfigurationTooltip(configuration)"
                  matTooltipPosition="left"
                >
                  <button
                    mat-menu-item
                    [disabled]="!canCloneConfiguration(configuration)"
                    (click)="onCloneConfiguration(configuration)"
                  >
                    {{ t('duplicate') }}
                  </button>
                </div>
              }
              @if (!isReadOnly && !configuration.layer) {
                <div>
                  <button mat-menu-item disabled>{{ t('import') }}</button>
                  <div [matTooltip]="importConfigurationTooltip()" matTooltipPosition="left">
                    <button
                      mat-menu-item
                      [disabled]="isReadOnly || configuration.removed"
                      (click)="onImportIntoConfiguration()"
                      class="configuration-details__import-button"
                    >
                      {{ t('import-from-configuration') }}
                    </button>
                  </div>
                  <div [matTooltip]="importConfigurationTooltip()" matTooltipPosition="left">
                    <button
                      mat-menu-item
                      [disabled]="isReadOnly || configuration.removed"
                      (click)="onUploadConfiguration()"
                      class="configuration-details__import-button"
                    >
                      {{ t('import-from-file') }}
                    </button>
                  </div>
                </div>
              }
              @if (!isReadOnly) {
                <div
                  [matTooltip]="deleteConfigurationTooltip(configuration)"
                  matTooltipPosition="left"
                >
                  <button
                    mat-menu-item
                    [disabled]="!canDeleteConfiguration(configuration)"
                    (click)="onDeleteConfiguration(configuration)"
                  >
                    {{ t('delete') }}
                  </button>
                </div>
              }
            </mat-menu>
          </div>
        }
      </div>
      <div class="configuration-details__notes-tags-wrapper">
        @if (visibilityOptions.showConfigDescription && configuration.notes.length > 0) {
          <div class="configuration-details__notes">
            <p>
              {{ configuration.notes || '' }}
            </p>
          </div>
        }
        @if (visibilityOptions.showConfigTags && hasTags) {
          <div class="configuration-details__tags-wrapper">
            <app-tag-autowrap
              [configuration]="configuration"
              class="configuration-details__tags"
            ></app-tag-autowrap>
          </div>
        }
      </div>
      <xi-horizontal-tab-bar
        [data]="tabs"
        [activeTabId]="activeTabId"
        [hasTransparentBackground]="true"
        [stretch]="true"
        [tabSpacing]="25"
        [tooltip]="{ text: 'test' }"
        color="CX"
        (onTabChange)="interceptTabChange($event.detail.tab.id)"
      >
      </xi-horizontal-tab-bar>
      <div class="configuration-details__tabs">
        @if (configuration?.layer) {
          <app-configuration-layers
            [ngClass]="
              activeTabId === 'layers'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLimits]="configurationLimits"
            [configurationLayers]="configurationLayers"
            [industryPacks]="industryPacks"
            [languageTemplates]="languageTemplates"
            (itemCountChange)="updateLimitUsed('layers', $event)"
            (itemCountSet)="setLimitUsed('layers', $event)"
            (layerHasChanges)="onConfigurationLayersChanged($event)"
          ></app-configuration-layers>
        }
        @if (sentimentTabLoaded) {
          <app-configuration-sentiment
            [ngClass]="
              activeTabId === 'sentiment'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLayers]="configurationAncestorLayers"
            [editable]="!configuration.layer"
            (itemCountChange)="updateLimitUsed('sentiment', $event)"
            (itemCountSet)="setLimitUsed('sentiment', $event)"
          ></app-configuration-sentiment>
        }
        @if (queriesTabLoaded) {
          <app-configuration-query-topics
            [ngClass]="
              activeTabId === 'queries'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLayers]="configurationAncestorLayers"
            [editable]="!configuration.layer"
            [taxonomyItemUsage]="taxonomyItemUsage"
            [tabIsActive]="activeTabId === 'queries'"
            (itemCountChange)="updateLimitUsed('queries', $event)"
            (itemCountSet)="setLimitUsed('queries', $event)"
          ></app-configuration-query-topics>
        }
        @if (entitiesTabLoaded) {
          <app-configuration-entities
            [ngClass]="
              activeTabId === 'entities'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLayers]="configurationAncestorLayers"
            [editable]="!configuration.layer"
            [taxonomyItemUsage]="taxonomyItemUsage"
            (itemCountChange)="updateLimitUsed('entities', $event)"
            (itemCountSet)="setLimitUsed('entities', $event)"
          ></app-configuration-entities>
        }
        @if (taxonomyTabLoaded) {
          <app-configuration-taxonomy
            [ngClass]="
              activeTabId === 'taxonomy'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLayers]="configurationAncestorLayers"
            [editable]="!configuration.layer"
            (itemCountChange)="updateLimitUsed('taxonomy', $event)"
            (itemCountSet)="setLimitUsed('taxonomy', $event)"
            (taxonomyTreeSave)="onTaxonomyTreeSaved()"
          ></app-configuration-taxonomy>
        }
        @if (conceptsTabLoaded) {
          <app-configuration-concept-topics
            [ngClass]="
              activeTabId === 'concept_topics'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLayers]="configurationAncestorLayers"
            [editable]="!configuration.layer"
            [taxonomyItemUsage]="taxonomyItemUsage"
            (itemCountChange)="updateLimitUsed('concept_topics', $event)"
            (itemCountSet)="setLimitUsed('concept_topics', $event)"
          ></app-configuration-concept-topics>
        }
        @if (blacklistTabLoaded) {
          <app-configuration-blacklist
            [ngClass]="
              activeTabId === 'blacklist'
                ? 'configuration-details__show'
                : 'configuration-details__hide'
            "
            #configTab
            [configuration]="configuration"
            [configurationLayers]="configurationAncestorLayers"
            [editable]="!configuration.layer"
            (itemCountChange)="updateLimitUsed('blacklist', $event)"
            (itemCountSet)="setLimitUsed('blacklist', $event)"
          ></app-configuration-blacklist>
        }
      </div>
    }
  </div>

  <!-- Clone Configuration Modal -->
  @if (showCloneConfigurationDialog) {
    <app-lex-xi-modal
      [isVisible]="showCloneConfigurationDialog"
      maxWidth="512px"
      (close)="onCloseCloneConfigurationDialog(null)"
    >
      <ng-template appXIModalContent>
        @if (showCloneConfigurationDialog) {
          <app-clone-configuration-dialog
            [data]="cloneConfigData"
            (modalClosed)="onCloseCloneConfigurationDialog($event)"
          ></app-clone-configuration-dialog>
        }
      </ng-template>
    </app-lex-xi-modal>
  }
  @if (showUploadDialog) {
    <app-import-dialog
      [isShowing]="showUploadDialog"
      [title]="t('import-title')"
      [description]="t('import-content')"
      [itemValidator]="uploadValidator"
      (modalClosed)="onCloseUploadConfigurationDialog($event)"
    >
    </app-import-dialog>
  }
  @if (showImportIntoConfiguration) {
    <app-import-into-configuration-drawer
      [groupId]="importConfigData.groupId"
      [targetConfiguration]="importConfigData.targetConfigDto"
      [sourceConfiguration]="importConfigData.sourceConfigDto"
      [inputFile]="importConfigData.inputFile"
      [accountLimits]="accountLimits"
      [open]="showImportIntoConfiguration"
      (close)="onCloseImportIntoConfiguration($event)"
    ></app-import-into-configuration-drawer>
  }
  @if (!isReadOnly) {
    <app-test-configuration-drawer
      [open]="showTestConfigurationDrawer"
      [configuration]="configuration"
      [configurationLimits]="configurationLimits"
      (close)="onCloseTestConfiguration()"
    ></app-test-configuration-drawer>
  }
  @if (showConfigurationOptions) {
    <app-configuration-settings-drawer
      [open]="showConfigurationOptions"
      [(configuration)]="configuration"
      [visibilityOptions]="visibilityOptions"
      [summaryLimit]="summaryLimit"
      [isReadOnly]="isReadOnly"
      [hasAutoAnalysis]="autoAnalysisConfigs.includes(configuration.id)"
      [templateConfiguration]="templateConfiguration"
      [industryPacks]="industryPacks"
      [languageTemplates]="languageTemplates"
      (close)="onCloseConfigurationOptions($event)"
    >
    </app-configuration-settings-drawer>
  }
</ng-container>
